import src from "IMAGE";
export default { src, width: 3413, height: 600, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAwUamkMElpWRUl7Rl9om1FXa5hUUGyOUUxzjVNGcoROpSgLNkl51H4AAAAASUVORK5CYII="};
